import { render, staticRenderFns } from "./Special_Announcement.vue?vue&type=template&id=dc788c42&scoped=true"
import script from "./Special_Announcement.vue?vue&type=script&lang=js"
export * from "./Special_Announcement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc788c42",
  null
  
)

export default component.exports